import {
  Autocomplete,
  AutocompleteInputChangeReason,
  FormControl,
  TextField,
} from "@mui/material";
import { SyntheticEvent, useCallback, useState } from "react";
import { useAddressAutocompleteQuery } from "src/api/services/placesApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { AutocompletePrediction } from "src/api/types";
import Spinner from "../Spinner";

interface Props {
  onSelect: (placeId: string | null) => void;
}

const PlacesAutocomplete = ({ onSelect }: Props) => {
  const [search, setSearch] = useState("");

  const { data: predictions = [], isFetching } = useAddressAutocompleteQuery(
    search.length < 6 ? skipToken : search
  );

  const handleAddressChange = useCallback(
    (
      _: SyntheticEvent,
      value: string,
      reason: AutocompleteInputChangeReason
    ) => {
      if (reason === "clear") {
        onSelect(null);
      }
      setSearch(value);
    },
    [onSelect]
  );

  const handleChange = useCallback(
    (
      _: React.SyntheticEvent,
      newValue: string | AutocompletePrediction | null
    ) => {
      if (newValue != null && typeof newValue === "object") {
        onSelect(newValue.place_id);
      }
    },
    [onSelect]
  );

  return (
    <FormControl error={search.length < 6} fullWidth required>
      <Autocomplete
        loading={isFetching}
        inputValue={search}
        options={predictions}
        onChange={handleChange}
        getOptionLabel={(o) => (typeof o === "string" ? o : o.description)}
        onInputChange={handleAddressChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search"
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isFetching ? <Spinner size="30px" /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              },
            }}
          />
        )}
      />
    </FormControl>
  );
};

export default PlacesAutocomplete;
